module.exports = __webpack_public_path__ + "img/sample-report-fr_CA.5ead3fcb.png";